/**
 * Экран «Telegram не отдал данные для входа».
 *
 * Отличается от `<BotDisabledScreen>` принципиально: там проблема с ботом или аккаунтом,
 * тут запрос к нам вообще не уходил. Раньше оба случая выглядели одинаково, и клиент шёл
 * ругаться к партнёру на «сломанный бот», хотя у него самого оборвалась связь или
 * недоступен telegram.org (свой VPN, блокировки).
 */

import { useTranslation } from 'react-i18next';
import { WifiOff } from 'lucide-react';

export function TelegramUnavailableScreen({ reason }: { reason: 'no_sdk' | 'no_init_data' }) {
  const { t } = useTranslation();
  const noSdk = reason === 'no_sdk';

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 space-y-6">
      <div className="w-24 h-24 rounded-3xl bg-amber-500/15 border border-amber-500/30 flex items-center justify-center">
        <WifiOff className="w-12 h-12 text-amber-500" />
      </div>
      <div className="text-center space-y-2 max-w-sm">
        <h2 className="text-xl font-bold">{noSdk ? t('Tg offline title') : t('Tg no init data title')}</h2>
        <p className="text-sm text-muted-foreground">
          {noSdk ? t('Tg offline description') : t('Tg no init data description')}
        </p>
      </div>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="px-6 py-3 bg-primary text-primary-foreground rounded-xl text-sm font-bold"
      >
        {t('Tg offline retry')}
      </button>
    </div>
  );
}
